var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageFallback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#E0EBFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.733 11.875H14.422c-3.453 0-6.297 2.794-6.297 6.229V43.02c0 3.435 2.844 6.229 6.297 6.229h31.281c3.453 0 6.297-2.659 6.297-6.094V18.104c0-3.435-2.811-6.229-6.267-6.229Zm-7.836 6.23a4.672 4.672 0 1 1-4.7 4.672 4.692 4.692 0 0 1 4.7-4.673ZM14.38 46.136c-1.726 0-3.032-1.396-3.032-3.114v-6.584l9.187-8.205a4.727 4.727 0 0 1 6.443.186l6.362 6.308-11.477 11.408-7.483.001Zm34.37-3.115a3.113 3.113 0 0 1-3.119 3.114H26.305l11.89-11.815a4.697 4.697 0 0 1 6.038-.016l4.517 3.834v4.883Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 3.75H6.5a6.5 6.5 0 0 0-6.5 6.5v26a6.511 6.511 0 0 0 4.875 6.297v-26.61a7.312 7.312 0 0 1 7.313-7.312h33.109A6.512 6.512 0 0 0 39 3.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h52v52H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFallback);
export default __webpack_public_path__ + "static/media/image-fallback.e6b1c343f6e78162ed04fd78307f8918.svg";
export { ForwardRef as ReactComponent };